module.exports = __webpack_public_path__ + "img/TableStory.0ac1a6d4.png";